import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type LabResultCardConfig } from './lab-result-card.types';

@Component({
  selector: 'app-lab-result-card',
  templateUrl: './lab-result-card.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabResultCard {
  readonly config = input.required<LabResultCardConfig>();

  readonly action = output<DynamicAction | undefined>();

  protected readonly hasTitle = computed(() => !!this.config().title);
  protected readonly hasBorder = computed(() => this.config().hasBorder ?? false);

  protected readonly titleConfig = computed(() => ({
    text: this.config().title,
    size: 'xl' as const,
    fontWeight: 'semibold' as const,
    fontFamily: 'var(--labresultcard-font-family)',
    cssVarPrefix: 'labresultcard-title',
  }));

  protected readonly primaryTextConfig = computed(() => ({
    text: this.config().primaryText,
    size: 'xl' as const,
    fontWeight: 'semibold' as const,
    cssVarPrefix: 'labresultcard-title',
  }));

  protected readonly secondaryTextConfig = computed(() => ({
    text: this.config().secondaryText,
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    fontFamily: 'var(--labresultcard-font-family)',
    cssVarPrefix: 'labresultcard-title',
  }));

  protected readonly supportingTextConfig = computed(() => ({
    text: this.config().supportingText,
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    fontFamily: 'var(--labresultcard-font-family)',
    cssVarPrefix: 'labresultcard-supporting-text',
  }));

  protected readonly chipConfig = computed(() => this.config().chip);

  protected onTitleClick(): void {
    this.action.emit(this.config().action);
  }
}
